/* eslint-disable max-lines */
import * as React from "react";

import { ReferralReportVersion } from "@teamprevent/common/referralReport/models";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { ReferralReport } from "../../referralReport/components/ReferralReport";
import { AmendReferralReport } from "../../referralReport/components/AmendReferralReport";
import { PpqReport } from "../../ppqReport";
import { PpqClinicalNotes } from "../../clinicalNotes/components/PpqClinicalNotes";
import { AllImmsCompletedForRoleCertificate } from "../../ppq/AllImmsCompletedForRoleCertificate";
import { OldReferralClinicalNotes } from "../../clinicalNotes/components/OldReferralClinicalNotes";
import { ReferralClinicalNotes as ReferralClinicalNotesV2_V3 } from "../../clinicalNotes/components/ReferralClinicalNotesV2_V3";
import { ReferralClinicalNotes } from "../../clinicalNotes/components/ReferralClinicalNotesV4";
import { BbvReport } from "../../bbvReport/components/bbvReport";
import { BbvConsultation } from "../../bbvConsultation/components/bbvConsultation";
import { ImmunisationBloodTestConsultation } from "../../bloodTest/components/ImmunisationBloodTestConsultation";
import { BbvBloodTestConsultation } from "../../bloodTest/components/BbvBloodTestConsultation";
import { BbvVaccinationConsultationNotes } from "../../vaccinationConsultation/components/BbvVaccinationConsultationNotes";
import { ImmunisationVaccinationConsultationNotes } from "../../vaccinationConsultation/components/ImmunisationVaccinationConsultationNotes";
import { ImmunisationReview } from "../../immunisationReview/components/immunisationReview";
import { HealthSurveillanceEmployeeQuestionnaireForTask } from "../../healthSurveillance/components/HealthSurveillanceEmployeeQuestionnaireForTask";
import { HealthSurveillanceClinicalNotes } from "../../healthSurveillance/clinicalNotes/components/HealthSurveillanceClinicalNotes";
import { HealthSurveillanceCertificate } from "../../healthSurveillance/certificate/components/HealthSurveillanceCertificate";
import { PpqDeclarationReview } from "../../healthSurveillance/ppqDeclarationReview/components/PpqDeclarationReview";
import { GenericCaseClinicalNotes } from "../../genericCases/clinicalNotes/components/GenericCaseClinicalNotes";
import { ImmunisationClearCertificate } from "../../immunisationOhCase/ImmunisationClearCertificate";
import { PhysiotherapyAssessmentClinicalNotesV2 } from "../../physiotherapy/clinicalNotes/components/PhysiotherapyAssessmentClinicalNotesV2";
import { PhysiotherapyReferralReportV2 } from "../../physiotherapyReferralReport/components/PhysiotherapyReferralReportV2";
import { AmendPhysiotherapyReferralReportV2 } from "../../physiotherapyReferralReport/components/AmendPhysiotherapyReferralReportV2";
import { AmendPhysiotherapyReferralReport as AmendPhysiotherapyReferralReportV3 } from
    "../../physiotherapyReferralReport/components/AmendPhysiotherapyReferralReportV3";

import { InitialWorkAdjustmentQuestionnaire } from "../../workAdjustment/components/InitialWorkAdjustmentQuestionnaire";
import { ManagerFeedbackOnReportForm } from "../../managerFeedbackOnReport/components/ManagerFeedbackOnReportForm";
import { HavsClinicalAssessmentOfHistoryAndExamination } from "../../healthSurveillance/components/HavsClinicalAssessmentOfHistoryAndExamination";
import { ReadonlyFastTrackPitPupMedicalForm } from "../../fastTrackPitPupMedicalForm/components/ReadonlyFastTrackPitPupMedicalForm";
import { EmployeeSatisfactionSurvey } from "../../employeeSatisfactionSurvey/components/EmployeeSatisfactionSurvey";
import { SatisfactionFollowUpQuestionnaire } from "../../managerSatisfactionFollowUpQuestionnaire/components/SatisfactionFollowUpQuestionnaire";
import { IaptViewCompletedQuestionnaire } from "../../clinicalNotes/components/IaptViewCompletedQuestionnaire";
import { MHPTreatmentConsultation } from "../../mentalHealthPractitionerTreatment/components/MHPTreatmentConsultation";
import { MHPTreatmentReport } from "../../mentalHealthPractitionerTreatment/components/MHPTreatmentReport";
import { AmendMHPTreatmentReport } from "../../mentalHealthPractitionerTreatment/components/AmendMHPTreatmentReport";
import { GPSpecialistLetter } from "../../generalPractitionerSpecialistInfo/components/GPSpecialistLetter";

import { QAAmendReferralReport } from "../../referralReport/components/QAAmendReferralReport";
import { QAAmendPhysiotherapyReferralReportV2 } from "../../physiotherapyReferralReport/components/QAAmendPhysiotherapyReferralReportV2";
import { QAAmendPhysiotherapyReferralReport as QAAmendPhysiotherapyReferralReportV3 } from
    "../../physiotherapyReferralReport/components/QAAmendPhysiotherapyReferralReportV3";
import { QAAmendMHPTreatmentReport } from "../../mentalHealthPractitionerTreatment/components/QAAmendMHPTreatmentReport";

import { EditReferralReport } from "../../referralReport/components/EditReferralReport";

import { PhysiotherapyReferralClinicalNotes } from "../../clinicalNotes/components/PhysiotherapyReferralClinicalNotesV4";

import { PhysiotherapyReferralClinicalNotes as PhysiotherapyReferralClinicalNotesV3 } from
    "../../clinicalNotes/components/PhysiotherapyReferralClinicalNotesV3";

import { PhysiotherapyReferralReport as PhysiotherapyReferralReportV3 } from "../../physiotherapyReferralReport/components/PhysiotherapyReferralReportV3";
import { PhysiotherapyReferralReport } from "../../physiotherapyReferralReport/components/PhysiotherapyReferralReportV4";

import { HealthSurveillanceConsultationForTask } from "../../healthSurveillance/components/HealthSurveillanceConsultationForTask";

import { AmendPpqClinicalNotes } from "../../clinicalNotes/components/AmendPpqClinicalNotes";

import { ApplicationState } from "../../applicationState";

import { loadEmployeeRecordDetail } from "../../crud/employeeRecord/actions";

import { loadOhCaseDetail } from "../../crud/ohCase/actions";

import { ohCase } from "../../crud/ohCase/selectors";

import { employeeRecord } from "../../crud/employeeRecord/selectors";

import { AmendPhysiotherapyReferralReport } from "../../physiotherapyReferralReport/components/AmendPhysiotherapyReferralReportV4";
import { QAAmendPhysiotherapyReferralReport } from "../../physiotherapyReferralReport/components/QAAmendPhysiotherapyReferralReportV4";

import { ActionBbvTaskModal } from "./closeTaskAndCreateFollowUpTask/ActionBbvTaskModal";
import { CreateRecall } from "./createMedicalRecall/CreateRecall";
import { ActionFurtherInformationAndReviewOfFitnessModal } from "./furtherInformationAndReviewOfFitness/ActionFurtherInformationAndReviewOfFitnessModal";
import { WriteToGeneralPractitionerSpecialistModal } from "./generalPractitionerSpecialist/WriteToGeneralPractitionerSpecialistModal";
import { SendLetterToGeneralPractitionerSpecialistModal } from "./generalPractitionerSpecialist/SendLetterToGeneralPractitionerSpecialistModal";

import { ActionGeneralTaskModal } from "./closeTaskAndCreateFollowUpTask/ActionGeneralTaskModal";

import { Fragment } from "redux-little-router";

export const TaskActionSubRoutes: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const customerId = useSelector((state: ApplicationState) => state.router.params?.customerId);
    const employeeRecordId = useSelector((state: ApplicationState) => state.router.params?.employeeRecordId);
    const ohCaseId = useSelector((state: ApplicationState) => state.router.params?.ohCaseId);
    const existingOhCase = useSelector(ohCase);
    const existingEmployeeRecord = useSelector(employeeRecord);

    React.useEffect(() => {
        if (customerId && employeeRecordId && !existingEmployeeRecord) {
            dispatch(loadEmployeeRecordDetail({ customerId, employeeRecordId }));
        }
    }, [customerId, dispatch, employeeRecordId, existingEmployeeRecord]);

    React.useEffect(() => {
        if (customerId && ohCaseId && !existingOhCase) {
            dispatch(loadOhCaseDetail({ ohCaseId, customerId }));
        }
    }, [customerId, dispatch, existingOhCase, ohCaseId]);

    return (
        <>
            <Fragment forRoute="/:taskId/bbvConsultation">
                <BbvConsultation />
            </Fragment>
            <Fragment forRoute="/:taskId/immunisationVaccinationConsultationNotes">
                <ImmunisationVaccinationConsultationNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/immunisationVaccinationConsultationNotesPrint">
                <ImmunisationVaccinationConsultationNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/bbvVaccinationConsultationNotes">
                <BbvVaccinationConsultationNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/referralClinicalNotes">
                <ReferralClinicalNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/oldReferralClinicalNotes/3">
                <ReferralClinicalNotesV2_V3 />
            </Fragment>
            <Fragment forRoute="/:taskId/oldReferralClinicalNotes/2">
                <ReferralClinicalNotesV2_V3 />
            </Fragment>
            <Fragment forRoute="/:taskId/oldReferralClinicalNotes/1">
                <OldReferralClinicalNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/ppqClinicalNotes">
                <PpqClinicalNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/amendPpqClinicalNotes">
                <AmendPpqClinicalNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/immunisationBloodTestConsultation">
                <ImmunisationBloodTestConsultation />
            </Fragment>
            <Fragment forRoute="/:taskId/bbvBloodTestConsultation">
                <BbvBloodTestConsultation />
            </Fragment>
            <Fragment forRoute="/:taskId/previewReport/2">
                <ReferralReport
                    version={ReferralReportVersion.V2}
                    isReportPreview
                />
            </Fragment>
            <Fragment forRoute="/:taskId/previewReport/3">
                <ReferralReport
                    version={ReferralReportVersion.V3}
                    isReportPreview
                />
            </Fragment>
            <Fragment forRoute="/:taskId/previewReport">
                <ReferralReport
                    version={ReferralReportVersion.Latest}
                    isReportPreview
                    oldVersionRedirectUrl={"/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/previewReport/:version"}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldReferralReport/1">
                <ReferralReport
                    version={ReferralReportVersion.V1}
                    nextTaskRequired
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldReferralReport/2">
                <ReferralReport
                    version={ReferralReportVersion.V2}
                    nextTaskRequired
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldReferralReport/3">
                <ReferralReport
                    version={ReferralReportVersion.V3}
                    nextTaskRequired
                />
            </Fragment>
            <Fragment forRoute="/:taskId/referralReport">
                <ReferralReport
                    version={ReferralReportVersion.Latest}
                    nextTaskRequired
                    oldVersionRedirectUrl={"/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/oldReferralReport/:version"}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldEditReferralReport/1">
                <EditReferralReport
                    version={ReferralReportVersion.V1}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldEditReferralReport/2">
                <EditReferralReport
                    version={ReferralReportVersion.V2}
                />
            </Fragment>

            <Fragment forRoute="/:taskId/oldEditReferralReport/3">
                <EditReferralReport
                    version={ReferralReportVersion.V3}
                />
            </Fragment>

            <Fragment forRoute="/:taskId/editReferralReport">
                <EditReferralReport
                    version={ReferralReportVersion.Latest}
                    oldVersionRedirectUrl={"/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/oldEditReferralReport/:version"}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldAmendReferralReport/1">
                <AmendReferralReport
                    version={ReferralReportVersion.V1}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldAmendReferralReport/2">
                <AmendReferralReport
                    version={ReferralReportVersion.V2}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldAmendReferralReport/3">
                <AmendReferralReport
                    version={ReferralReportVersion.V3}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/amendReferralReport">
                <AmendReferralReport
                    version={ReferralReportVersion.Latest}
                    oldVersionRedirectUrl={"/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/oldAmendReferralReport/:version"}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldQAAmendReferralReport/2">
                <QAAmendReferralReport
                    version={ReferralReportVersion.V2}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/oldQAAmendReferralReport/3">
                <QAAmendReferralReport
                    version={ReferralReportVersion.V3}
                />
            </Fragment>
            <Fragment forRoute="/:taskId/qaAmendReferralReport">
                <QAAmendReferralReport
                    version={ReferralReportVersion.Latest}
                    oldVersionRedirectUrl={
                        "/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/oldQAAmendReferralReport/:version"
                    }
                />
            </Fragment>
            <Fragment forRoute="/:taskId/bbvReport">
                <BbvReport />
            </Fragment>
            <Fragment forRoute="/:viewReportTaskId/view-ppq-report">
                <PpqReport />
            </Fragment>
            <Fragment forRoute="/:taskId/immunisationReview">
                <ImmunisationReview />
            </Fragment>
            <Fragment forRoute="/:taskId/immunisationCertificate">
                <ImmunisationClearCertificate />
            </Fragment>
            <Fragment forRoute="/:taskId/allImmunisationsCompletedForRoleCertificate">
                <AllImmsCompletedForRoleCertificate />
            </Fragment>
            <Fragment forRoute="/:taskId/action-bbv-task">
                <ActionBbvTaskModal />
            </Fragment>
            <Fragment forRoute="/:taskId/action-general-task">
                <ActionGeneralTaskModal />
            </Fragment>
            <Fragment forRoute="/:taskId/review-of-fitness">
                <ActionFurtherInformationAndReviewOfFitnessModal />
            </Fragment>
            <Fragment forRoute="/:taskId/write-to-gp-specialist">
                <WriteToGeneralPractitionerSpecialistModal />
            </Fragment>
            <Fragment forRoute="/:taskId/send-letter-to-gp-specialist">
                <SendLetterToGeneralPractitionerSpecialistModal />
            </Fragment>
            <Fragment forRoute="/:taskId/general-practitioner-specialist-letter">
                <GPSpecialistLetter />
            </Fragment>
            <Fragment forRoute="/:taskId/healthSurveillanceQuestionnaire">
                <HealthSurveillanceEmployeeQuestionnaireForTask />
            </Fragment>
            <Fragment forRoute="/:taskId/healthSurveillanceConsultation">
                <HealthSurveillanceConsultationForTask />
            </Fragment>
            <Fragment forRoute="/:taskId/healthSurveillanceClinicalNotes">
                <HealthSurveillanceClinicalNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/healthSurveillanceCertificate">
                <HealthSurveillanceCertificate />
            </Fragment>
            <Fragment forRoute="/:taskId/createRecall">
                <CreateRecall />
            </Fragment>
            <Fragment forRoute="/:taskId/ppqDeclarationReview">
                <PpqDeclarationReview />
            </Fragment>
            <Fragment forRoute="/:taskId/genericCaseClinicalNotes">
                <GenericCaseClinicalNotes />
            </Fragment>
            <Fragment forRoute="/:taskId/physiotherapyAssessmentConsultation">
                <PhysiotherapyReferralClinicalNotes />
            </Fragment>

            {/* Route for V3 needs to come before wildcard route */}
            <Fragment forRoute="/:taskId/oldPhysiotherapyAssessmentConsultation/3">
                <PhysiotherapyReferralClinicalNotesV3 />
            </Fragment>
            <Fragment forRoute="/:taskId/oldPhysiotherapyAssessmentConsultation/*">
                <PhysiotherapyAssessmentClinicalNotesV2 />
            </Fragment>

            {/* Route for V3 needs to come before wildcard route */}
            <Fragment forRoute="/:taskId/oldPhysiotherapyReferralReport/3">
                <PhysiotherapyReferralReportV3 version={ReferralReportVersion.V3} nextTaskRequired />
            </Fragment>

            <Fragment forRoute="/:taskId/oldPhysiotherapyReferralReport/*">
                <PhysiotherapyReferralReportV2 nextTaskRequired={true} isReportAmendment={false} />
            </Fragment>

            <Fragment forRoute="/:taskId/physiotherapyReferralReport">
                <PhysiotherapyReferralReport
                    version={ReferralReportVersion.Latest}
                    nextTaskRequired
                    oldVersionRedirectUrl={
                        "/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/oldPhysiotherapyReferralReport/:version"
                    }
                />
            </Fragment>

            {/* Route for V3 needs to come before wildcard route */}
            <Fragment forRoute="/:taskId/oldAmendPhysiotherapyReferralReport/3">
                <AmendPhysiotherapyReferralReportV3 version={ReferralReportVersion.V3} />
            </Fragment>

            <Fragment forRoute="/:taskId/oldAmendPhysiotherapyReferralReport/*">
                <AmendPhysiotherapyReferralReportV2 />
            </Fragment>

            <Fragment forRoute="/:taskId/amendPhysiotherapyReferralReport">
                <AmendPhysiotherapyReferralReport
                    version={ReferralReportVersion.Latest}
                    oldVersionRedirectUrl={
                        "/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/oldAmendPhysiotherapyReferralReport/:version"
                    }
                />
            </Fragment>

            {/* Route for V3 needs to come before wildcard route */}
            <Fragment forRoute="/:taskId/oldQAAmendPhysiotherapyReferralReport/3">
                <QAAmendPhysiotherapyReferralReportV3 version={ReferralReportVersion.V3} />
            </Fragment>

            <Fragment forRoute="/:taskId/oldQAAmendPhysiotherapyReferralReport/*">
                <QAAmendPhysiotherapyReferralReportV2 />
            </Fragment>
            <Fragment forRoute="/:taskId/qaAmendPhysiotherapyReferralReport">
                <QAAmendPhysiotherapyReferralReport
                    version={ReferralReportVersion.Latest}
                    oldVersionRedirectUrl={
                        "/customers/:customerId/employeeRecords/:employeeRecordId/ohCases/:ohCaseId/:taskId/oldQAAmendPhysiotherapyReferralReport/:version"
                    }
                />
            </Fragment>
            <Fragment forRoute="/:taskId/initialWorkAdjustmentQuestionnaire">
                <InitialWorkAdjustmentQuestionnaire />
            </Fragment>
            <Fragment forRoute="/:taskId/managerFeedbackOnReport">
                <ManagerFeedbackOnReportForm />
            </Fragment>
            <Fragment forRoute="/:taskId/havsClinicalAssessmentOfHistoryAndExamination">
                <HavsClinicalAssessmentOfHistoryAndExamination />
            </Fragment>
            <Fragment forRoute="/:taskId/fastTrackPitPupMedicalForm">
                <ReadonlyFastTrackPitPupMedicalForm />
            </Fragment>
            <Fragment forRoute="/:taskId/employeeSatisfactionSurvey">
                <EmployeeSatisfactionSurvey />
            </Fragment>
            <Fragment forRoute="/:taskId/followUpQuestionnaire">
                <SatisfactionFollowUpQuestionnaire />
            </Fragment>
            <Fragment forRoute="/:taskId/iaptViewCompletedQuestionnaire">
                <IaptViewCompletedQuestionnaire />
            </Fragment>
            <Fragment forRoute="/:taskId/mhpTreatmentConsultation">
                <MHPTreatmentConsultation />
            </Fragment>
            <Fragment forRoute="/:taskId/mhpTreatmentReport">
                <MHPTreatmentReport isReportPreview={false} nextTaskRequired={true} isReportAmendment={false} />
            </Fragment>
            <Fragment forRoute="/:taskId/previewMHPTreatmentReport">
                <MHPTreatmentReport isReportPreview={true} nextTaskRequired={false} isReportAmendment={false} />
            </Fragment>
            <Fragment forRoute="/:taskId/amendMHPTreatmentReport">
                <AmendMHPTreatmentReport />
            </Fragment>
            <Fragment forRoute="/:taskId/qaAmendMHPTreatmentReport">
                <QAAmendMHPTreatmentReport />
            </Fragment>
        </>
    );
};
